<template>
  <div  class="q-pa-md" style="">
    <el-container >
      <el-main>
        <label style="padding-left: 3px">
          <el-button size="small" @click="addUserVis = true" type="primary" plain icon="el-icon-s-check">添加角色</el-button>
          <!--<el-button size="small" @click="download" type="success" icon="el-icon-download">导出</el-button>-->
          <!--<el-button size="small" @click="uploadlogo" type="success" icon="el-icon-upload">上传logo</el-button>-->
          <el-dialog title="新增系统角色" width="30%" :visible.sync="addUserVis" class="class_dialog_hospital">
            <el-form>
              <el-form-item label="角色名：" >
                <el-input v-model.trim="roleName" placeholder="请输入角色名"></el-input>
              </el-form-item>
              <el-form-item label="权限设置：" >
                <el-select style="width: 100%" clearable filterable allow-create default-first-option v-model.trim="dataScope">
                  <el-option label="全部权限" value="0"></el-option>
                  <el-option label="本人及下级权限" value="1"></el-option>
                  <el-option label="本人权限" value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button size="small" @click="addUserVis = false">取 消</el-button>
              <el-button size="small" type="primary" plain @click="addRole()">确 定</el-button>
            </div>
          </el-dialog>
        </label>

        <el-table ref="multipleTable" :data="tableData" :row-style="{height:'40px',textAlign:'center'}"
                  :cell-style="{height:'5px,0',textAlign:'center'}"
                  :header-cell-style="{background: '#f5f7fa', color: '#606266',textAlign:'center'}"
                  border style="width: 100%;margin-top: 1%;height: 70vh">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="id" label="角色编号" min-width="120"></el-table-column>
          <el-table-column prop="roleName" label="角色名称" min-width="150"></el-table-column>
          <el-table-column prop="dataScope" label="所属权限" min-width="150"></el-table-column>
          <el-table-column prop="createTime" label="创建时间" min-width="180"></el-table-column>
          <el-table-column prop="createTime" label="更新时间" min-width="180"></el-table-column>
          <el-table-column prop="updateUser" label="更新人" min-width="150"></el-table-column>
          <el-table-column label="操作" min-width="120">
            <template slot-scope="scope">
              <el-button v-show="scope.row.roleId!=='777'" type="primary" plain size="mini" @click="gotoAuth(scope.row)">授权</el-button>
            </template>
          </el-table-column>
        </el-table>
        <pagination class="text-center" ref="pagination" v-bind:list="list" v-bind:itemCount="8"></pagination>

        <el-dialog  title="功能列表" :visible.sync="authVis" class="class_dialog_hospital" width="30%">
          <el-form v-loading="loading" element-loading-text="重新分配中" element-loading-spinner="el-icon-loading"
                   element-loading-background="rgba(0, 0, 0, 0.8)">
            <el-form-item label="角色名称：" >
              <el-input disabled v-model.trim="queryRole.roleName"/>
            </el-form-item>

            <el-form-item>
              <p>树形菜单：</p>
              <div style="border: 1px solid rgb(232 239 233);border-radius: 5px">
                <el-tree value="value" 	:data="queryRole.tree" ref="refTree"
                         :show-checkbox="true" node-key="id"  :props="defaultProps"></el-tree>
              </div>
            </el-form-item>

          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="authVis = false">取 消</el-button>
            <el-button size="small" type="primary" plain @click="startAuth()">确 定</el-button>
          </div>
        </el-dialog>
        <!--<el-dialog title="上传logo"         width="30%" :visible.sync="logoVis">
          <el-upload
            class="avatar-uploader"
            :action="uploadlogourl"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"

            :before-upload="beforeAvatarUpload"

          >
            <img v-if="imageUrl" :src="imageUrl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>      
        </el-dialog>-->
      </el-main>
    </el-container>
  </div>
</template>

<script>
import Pagination from '../../../components/pagination'


export default {
  name: 'role',
  components: {
    Pagination
  },

  mounted: function () {
    let _this = this
    _this.$refs.pagination.size = 10
    _this.list(1)
  },

  data() {
    return {
      dataScope:'',
      maxHeight: 600,
      value: '',
      checkedKeys: [],
      expandKeys: [],
      tree: [],
      authVis: false,
      user: '',
      roleName: '',
      addUserVis: false,
      logoVis: false,
      tableData: [],
      defaultProps: {
        children: 'childFunctionList',
        label: 'name'
      },
      imageUrl: '',
      uploadlogourl: process.env.VUE_APP_SERVER + '/system/uploadlogo',
      rolejs: require("../../../api/role"),
      funcjs: require("../../../api/funct"),
      loading: false,
      queryRole:{
        roleName:'',
        tree:[],

      }
    }
  },

  methods: {
    startAuth() {
      let _this = this
      _this.loading = true
      let id = _this.value
      let res = _this.$refs.refTree.getCheckedKeys()
      let pres = _this.$refs.refTree.getHalfCheckedKeys()

      let arr = []
      arr = res.concat(pres)
      if (arr.length === 0) {
        _this.$alert('请给角色授权')
        _this.loading = false
        return false
      }
      if(_this.$check.checkIsNull(_this.queryRole.dataScope)){
        _this.$alert('请给角色设置访问权限')
        _this.loading = false
        return false
      }

      let data={
        ids: arr.join(),
        rId: id,
      }
      _this.funcjs.startFuncAuth(data)
        .then(res => {
          _this.loading = false
          if (res.data.code === '0') {
            _this.$alert(res.data.data)
            _this.authVis = false
          } else {
            _this.$alert(res.data.msg)
            _this.authVis = false
          }
          _this.list(1)
        })
    },
    gotoAuth(row) {
      //展示当前角色所拥有的权限
      let _this = this
      _this.queryRole.tree=[]
      _this.value = row.id
      _this.checkedKeys = []
      _this.authVis = true
      _this.queryRole.roleName = row.roleName
      _this.queryRole.dataScope = row.dataScope
      _this.funcjs.loadTree().then(res => {
        if (res.data.code === '0') {
          let jsontree = res.data.data
          _this.queryRole.tree = eval(jsontree)
          //补充勾选角色
          let data={
            paramId: row.id
          }
          _this.funcjs.queryDzFunction(data)
            .then(res => {
              if (res.data.code === '0') {
                let keys = res.data.data
                keys.forEach(value => {
                  _this.$nextTick(function () {
                    _this.$refs.refTree.setChecked(value, true, false)
                  })
                })
              }
            })
        }
      })
    },

    addRole() {
      let _this = this
      if (_this.roleName === '') {
        _this.$alert('请输入角色名')
        return false
      }
      if (_this.dataScope === '') {
        _this.$alert('请设置角色权限')
        return false
      }
      //获取当前用户
      let account = JSON.parse(sessionStorage.getItem('loginUser'))
      _this.user = account.userName
      let data={
        account: _this.user,
        roleName: _this.roleName,
        dataScope: _this.dataScope
      }
      _this.rolejs.addRole(data)
        .then(res => {
          if (res.data.code === '0') {
            _this.$alert(res.data.data)
            _this.list(1)
          } else {
            _this.$alert(res.data.msg)
          }
        })
        .catch(error => {
          _this.$swal(error)
        })
      _this.addUserVis = false
    },
    list(page) {
      let _this = this
      _this.maxHeight = _this.$listenHeight.getBodyHeight()
      let data={
        current: page,
        size: _this.$refs.pagination.size,
        user: 'role'
      }
      _this.rolejs.getRole(data)
        .then(response => {
          if (response.data.code === '0') {
            _this.tableData = response.data.data.rows
          }
          _this.$refs.pagination.render(page, response.data.data.total)
        })
    },


  }
}
</script>

<style lang="less" scoped>

  /* 设置滚动条宽度和高度 */
  ::v-deep .el-table__body-wrapper::-webkit-scrollbar {
    width: 10px; /* 横向滚动条 */
    height: 10px; /* 纵向滚动条 必写 */
  }
  /* 设置滚动条样式 */
  ::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
    background-color: #dde;
    border-radius: 3px;
  }
  ::v-deep .el-table {
    height: 88%;
  .el-table__body-wrapper {
    height: calc(100% - 48px) !important; // 表格高度减去表头的高度
  overflow-y: auto;
  }
  }

/deep/.el-input {
  width: 90%;
}

/deep/.el-main {
  text-align: left;
  padding: 20px !important;
  overflow: hidden !important;
}
/deep/.el-table .el-table__cell {
  padding: 0px;
}
/deep/thead.has-gutter {
  height: 40px;
}


</style>
<style scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 278px;
  height: 78px;
  display: block;
}
input[type='file'] {
  display: none !important;
}
</style>